import { useEffect } from "react";
import { fetchSettings as apiFetchSettings } from "@/lib/api";

// Periodic meter refresh.
// The hype meter drains over 48h since last feed. Re-fetch settings every
// 30s (and on window focus) so the UI reflects the decay in real time
// without forcing a page reload.
export function useMeterRefresh(setSettings) {
    useEffect(() => {
        const tick = async () => {
            try {
                const s = await apiFetchSettings();
                setSettings((prev) => ({ ...(prev || {}), ...s }));
            } catch (e) {
                console.warn("meter refresh failed (non-critical)", e);
            }
        };
        const id = setInterval(tick, 30_000);
        const onFocus = () => tick();
        window.addEventListener("focus", onFocus);
        return () => {
            clearInterval(id);
            window.removeEventListener("focus", onFocus);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
